import { Container, Grid, IconButton, Tab, Tabs, Typography, styled, useTheme } from "@mui/material";
import { getHistoryCryptoForm, getHistoryFiatForm } from "store/slices/wallet/walletSlice";
import { useEffect, useMemo, useState } from "react";

import { Filter } from "assets/Icon";
import { NETWORK_TYPES } from "pages/Deposit/constants";
import { WITHDRAW_DEPOSIT_HISTORY_TABS } from "./constants";
import WithdrawOrDepositHistoryFilter from "./Components/WithdrawOrDepositHistoryFilter";
import WithdrawOrDepositHistoryTable from "./Components/WithdrawOrDepositHistoryTable";
import useDispatch from "hooks/useDispatch";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function WithdrawOrDepositHistory({ hideTypeTabs = false, showWalletType, show24h }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [showOrHideFilters, setShowOrHideFilters] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const sideId = +searchParams.get("sideId") || 0;
  const inSideId = +searchParams.get("inSideId") || 0;
  const historyForm = useSelector((state) => state.wallet.historyForm?.data);
  const isDigital = searchParams.get("isDigital")?.toLocaleLowerCase() !== "false";

  const handleChangeTab = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      sideId: newValue,
      inSideId: newValue === 0 ? null : inSideId
    });
  };

  const handleChangeInsideTab = (_, newValue) => {
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      inSideId: newValue,
    });
  };

  const handleChangeNetworkType = (_, tab) => {
    const tempIsDigital = tab === NETWORK_TYPES.crypto.networkId;

    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({ ...allSearchParams, isDigital: tempIsDigital });
  };

  const currentTab = isDigital ? NETWORK_TYPES.crypto.networkId : NETWORK_TYPES.fiat.networkId;

  const selectedSide = useMemo(() => Object.values(WITHDRAW_DEPOSIT_HISTORY_TABS).find((tab) => tab.id === sideId), [sideId]);

  const inSideTabs = useMemo(() => {
    return [
      {
        id: 0,
        name: `24H History`,
      },
      {
        id: 1,
        name: `All ${selectedSide?.value} histories`,
      }
    ]

  }, [selectedSide])

  useEffect(() => {
    if (isDigital) {
      dispatch(getHistoryCryptoForm());
    } else {
      dispatch(getHistoryFiatForm());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDigital]);


  return (
    <Container maxWidth="100%">
      <Grid container spacing={2}>
        {showWalletType && (
          <Grid item xs={12}>
            <TabsStyleNetwork
              value={currentTab}
              onChange={handleChangeNetworkType}
              aria-label="secondary tabs example"
            >
              {Object.values(NETWORK_TYPES)?.map((data, index) => (
                <Tab
                  value={data.networkId}
                  label={data.networkName}
                  key={index}
                />
              ))}
            </TabsStyleNetwork>
          </Grid>
        )}

        {!hideTypeTabs && (
          <>
            <Grid item xs={12} mt={5}>
              <Typography variant="h5" color="text.main">
                Recent {selectedSide?.historyText}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TabsStyleNetwork value={sideId} onChange={handleChangeTab}>
                {historyForm?.lisSide?.map((tab) => (
                  <Tab value={tab.id} label={tab.name} key={tab.id} />
                ))}
              </TabsStyleNetwork>
            </Grid>

            {(+sideId !== 0 && !show24h) &&
              <Grid item xs={12}>
                <TabsStyleInSide value={inSideId} onChange={handleChangeInsideTab}>
                  {inSideTabs?.map((tab) => (
                    <Tab value={tab.id} label={tab.name} key={tab.id} />
                  ))}
                </TabsStyleInSide>
              </Grid>
            }
          </>
        )}

        {!show24h &&
          <Grid item xs={12} textAlign="right" mb={1}>
            <IconButton onClick={() => setShowOrHideFilters((v) => !v)}>
              <Filter color={theme.palette.text.main} />
            </IconButton>
          </Grid>
        }
      </Grid>

      {showOrHideFilters && <WithdrawOrDepositHistoryFilter />}

      <WithdrawOrDepositHistoryTable isShowJust24h={show24h} />
    </Container>
  );
}

const TabsStyleNetwork = styled(Tabs)(({ theme }) => ({
  // borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
    maxWidth: "300px",
  },
}));

const TabsStyleInSide = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
    maxWidth: "300px",
  },
}));

export default WithdrawOrDepositHistory;
